export const emailEzmlm = {
  id: 'static-email-ezmlm',
  slug: 'email-ezmlm',
  title: 'Informazioni Email ezmlm: Messaggi automatici della mailing list',
  excerpt: 'Spiegazione sui messaggi automatici del sistema ezmlm della mailing list studi@unasca.it. Cosa sono e cosa fare se li ricevi.',
  body: `
    <div style="background-color: #d1ecf1; color: #0c5460; padding: 1.2rem; border-radius: 12px; margin-bottom: 2rem; border-left: 5px solid #bee5eb; display: flex; align-items: flex-start; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <i class="fas fa-info-circle" style="font-size: 1.5rem; margin-right: 1rem; margin-top: 0.2rem;"></i>
      <p><strong>Comunicazione importante:</strong> Molti associati stanno ricevendo messaggi automatici dal sistema ezmlm. Questa pagina spiega cosa sono questi messaggi e cosa fare.</p>
    </div>

    <h2>Messaggi ezmlm: Cosa sta succedendo?</h2>

    <p>Diversi associati hanno segnalato di aver ricevuto messaggi automatici dal sistema <strong>ezmlm</strong> relativi alla mailing list <strong>studi@unasca.it</strong>. Questi messaggi indicano problemi di consegna delle email.</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border-radius: 12px; padding: 1.5rem; margin: 2.5rem 0; border-left: 4px solid #00bf8f; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-question-circle"></i> Cos'è ezmlm?
      </h3>
      <p><strong>ezmlm</strong> è un gestore di mailing list che monitora automaticamente gli errori di consegna delle email e mantiene aggiornato l'elenco degli indirizzi attivi.</p>
    </div>

    <h2>Come funziona il sistema</h2>
    <p>Quando una email non viene consegnata, ezmlm intraprende azioni automatiche per mantenere la lista aggiornata:</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border-radius: 12px; padding: 1.5rem 1.5rem 1.5rem 3rem; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); margin: 2rem 0;">
      <ol>
        <li style="margin-bottom: 1rem;"><strong>Invia un messaggio di avviso</strong> all'indirizzo problematico</li>
        <li style="margin-bottom: 1rem;">Se l'avviso fallisce, <strong>invia un messaggio di prova</strong></li>
        <li style="margin-bottom: 1rem;">Se anche questo fallisce, <strong>rimuove automaticamente l'indirizzo</strong> dalla lista</li>
      </ol>
    </div>

    <h2>Cause principali dei problemi</h2>
    <ul>
      <li><strong>Caselle di posta piene</strong></li>
      <li><strong>Indirizzi email non più validi</strong></li>
      <li><strong>Filtri antispam</strong> che bloccano le email</li>
      <li><strong>Problemi temporanei del server</strong></li>
    </ul>

    <h2>Cosa fare se ricevi questi messaggi</h2>
    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border-radius: 12px; padding: 1.5rem 1.5rem 1.5rem 3rem; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); margin: 2rem 0;">
      <ul>
        <li style="margin-bottom: 1rem;"><strong>Verifica che la tua casella non sia piena</strong></li>
        <li style="margin-bottom: 1rem;"><strong>Assicurati che l'indirizzo email sia attivo</strong></li>
        <li style="margin-bottom: 1rem;"><strong>Aggiungi studi@unasca.it ai tuoi contatti</strong></li>
        <li style="margin-bottom: 1rem;"><strong>Controlla la cartella spam</strong></li>
        <li style="margin-bottom: 1rem;"><strong>Contatta la Segreteria</strong> se il problema persiste</li>
      </ul>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border-radius: 12px; padding: 1.5rem; margin: 2.5rem 0; border-left: 4px solid #00bf8f; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-lightbulb"></i> Importante da sapere
      </h3>
      <p>Questi messaggi <strong>non sono spam o truffe</strong>, ma notifiche automatiche del sistema di gestione della mailing list per mantenere aggiornato l'elenco degli indirizzi email attivi.</p>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.1) 0%, rgba(0, 21, 16, 0.05) 100%); border-radius: 12px; padding: 1.5rem; margin: 2.5rem 0; border-left: 4px solid #00bf8f; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-phone-alt"></i> Hai bisogno di aiuto?
      </h3>
      <p>Per qualsiasi dubbio o per aggiornare il vostro indirizzo email, contattate la <strong>Segreteria UNASCA</strong>. Il nostro team è a disposizione per assistervi.</p>
    </div>

    <div style="text-align: center; margin: 2rem 0;">
      <img src="/images/email-3249062_1280.png" alt="Illustrazione email" style="width: 100%; max-width: 600px; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
    </div>
  `,
  featuredImage: '/images/email-3249062_1280.png',
  category: {
    id: 'supporto-tecnico',
    name: 'Supporto Tecnico',
    slug: 'supporto-tecnico',
    color: '#3B82F6'
  },
  tags: ['Email', 'ezmlm', 'Mailing List', 'Supporto Tecnico', 'FAQ'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-05-26T10:00:00Z',
  createdAt: '2025-05-26T10:00:00Z',
  updatedAt: '2025-05-26T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 3
};

